import "./CreateApp.scss";
import { NavLink, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { registerNewUserAPI, createNewAppAPI } from "../api/ClientApi";
import { useDispatch } from "react-redux";
import { handleLogoutRedux } from "../../redux/actions/userAction";
const CreateApp = (props) => {
  const [appId, setAppId] = useState("");
  const [appName, setAppName] = useState("");
  const [bundleId, setBundleId] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const [appUrl, setAppUrl] = useState("");

  const [os, setOS] = useState("ios");
  const containsWhitespace = (str) => /\s/.test(str);

  const defaultObjectCheck = {
    isValidAppID: true,
    isValidAppName: true,
    isValidBundleId: true,
    isValidIconUrl: true,
    isValidOS: true,
    isValidAppUrl: true,
  };
  const [objectCheckInput, setObjectCheckInput] = useState(defaultObjectCheck);
  const history = useHistory();
  const dispatch = useDispatch();
  // useEffect(() => {}, []);
  const handleRegister = () => {
    let invalid = invalidInputs();
    // console.log("User Data Register,", JSON.stringify(userData));
    if (invalid) {
      createNewAppAPI({
        appId,
        appName,
        bundleId,
        iconUrl,
        os,
        appUrl,
      }).then((response) => {
        let { errorCode, message } = response;
        if (errorCode === 0) {
          toast.success(message);
          history.push("/admin");
        } else if (errorCode === 401) {
          toast.error(message);
          dispatch(handleLogoutRedux());
        } else {
          toast.error(message);
        }
      });
    }
  };

  const invalidInputs = () => {
    setObjectCheckInput(defaultObjectCheck);
    if (!appId) {
      toast.error("App id is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidAppID: false });
      return false;
    }
    if (!appName) {
      toast.error("App name is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidAppName: false });
      return false;
    }

    if (!bundleId) {
      toast.error("Bundle id is not empty!");
      setObjectCheckInput({
        ...defaultObjectCheck,
        isValidBundleId: false,
      });

      return false;
    }
    if (!iconUrl) {
      toast.error("Icon url is not empty!");
      setObjectCheckInput({
        ...defaultObjectCheck,
        isValidIconUrl: false,
      });
      return false;
    }
    if (!os) {
      toast.error("OS is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidOS: false });
      return false;
    }
    if (containsWhitespace(appId)) {
      toast.error("App id is not contain whitespace!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidAppID: false });
      return false;
    }
    return true;
  };

  return (
    <div className="Register-container">
      <div className="container">
        <div className="row">
          <div className="content-right mt-3 col-12 col-sm-5 d-flex flex-column gap-3 py-3 shadow-lg p-3 mb-5 bg-body rounded">
            {/* <div class="brand">Facebook</div> */}
            <input
              className={
                objectCheckInput.isValidAppID
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="App ID"
              value={appId}
              onChange={(event) => setAppId(event.target.value)}
            />
            <input
              className={
                objectCheckInput.isValidAppName
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="App Name"
              value={appName}
              onChange={(event) => setAppName(event.target.value)}
            />
            <input
              className={
                objectCheckInput.isValidBundleId
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="BundleId"
              value={bundleId}
              onChange={(event) => setBundleId(event.target.value)}
            />
            <input
              className={
                objectCheckInput.isValidIconUrl
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="Icon url"
              value={iconUrl}
              onChange={(event) => setIconUrl(event.target.value)}
            />
            <input
              className={
                objectCheckInput.isValidAppUrl
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="App url"
              value={appUrl}
              onChange={(event) => setAppUrl(event.target.value)}
            />
            <div className="col-3">
              <select
                className="form-select"
                value={os}
                onChange={(event) => {
                  setOS(event.target.value);
                }}
              >
                <option selected value={"ios"}>
                  IOS
                </option>
                <option value={"android"}>Android</option>
              </select>
            </div>

            <button
              className="btn btn-primary"
              onClick={() => handleRegister()}
            >
              Create App
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateApp;
